export const iconFontAwesomeUsersPeoplePersonSkating = (
	<i className="fa-solid fa-person-skating"></i>
);
